//mui error alert component
import React from 'react'
import { Alert as MuiAlert } from '@mui/material'

const CustomAlert = ({text}) => {
  return (
    <MuiAlert severity="error">{text}</MuiAlert>
  )
}

export default CustomAlert